<template>
  <div class="third looking-setting">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">服务中心配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default"
            >重置</el-button
          >
          <el-button
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
            @click="submitFN()"
            >保存</el-button
          >
        </div>
      </div>
      <el-form
        ref="formList"
        :model="formList"
        :rules="rules"
        :show-message="false"
        label-width="100px"
        @validate="validateValue"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px" v-if="true">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">服务卡片</span>
              </div>
            </div>
            <div class="one-list myform serviceClass">
              <el-form-item label="卡片名称" :rules="[{ required: true }]">
                <!-- <div class="one-list">
                    <div class="list-one-line">
                        <el-form-item label="常用服务" prop="officialUrl">
                            <el-input
                            class="list-input myInput_config"
                            :maxlength="6"
                            v-model.trim="formList.officialUrl"
                            placeholder="请输入常用服务"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="推荐服务" prop="officialUrl">
                            <el-input
                            class="list-input myInput_config"
                            :maxlength="6"
                            v-model.trim="formList.officialUrl"
                            placeholder="请输入推荐服务"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="上新服务" prop="officialUrl">
                            <el-input
                            class="list-input myInput_config"
                            :maxlength="6"
                            v-model.trim="formList.officialUrl"
                            placeholder="请输入上新服务"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div> -->
                <div class="one-list">
                  <div class="list-one-line">
                    <el-form-item
                      v-for="(item, index) in formList.cardNameVOS"
                      :label="item.fieldName"
                      :prop="'cardNameVOS.' + index + '.value'"
                      :rules="{
                            required:true,
                            message: `请输入${item.fieldName}卡片展示名称`,
                            trigger: 'blur',
                          }"
                      :key="index"
                    >
                          <el-input
                            class="list-input myInput_config"
                            :maxlength="6"
                            v-model.trim="item.value"
                            :placeholder="`请输入${item.fieldName}卡片展示名称`"
                          ></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one" v-if="true">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">服务分类</span>
                <span
                  style="
                    font-size: 12px;
                    display: inline-block;
                    margin-top: 2px;
                    margin-left: 10px;
                    color: #ff4d4f;
                  "
                  >点击字段不放可拖动字段顺序</span
                >
              </div>
            </div>
            <div class="one-list myform serviceClass">
              <el-form-item label="展示分类" :rules="[{ required: true }]">
                <div class="one-list-two">
                  <div class="list-one-line">
                    <el-form-item
                      v-for="(item, index) in formList.serviceCategoryVOS"
                       style="cursor: pointer;"
                      :key="index"
                    >
                      <div style="display: flex" class="showItem">
                        <!-- <el-checkbox
                            :disabled="item.isCustom === 2"
                            v-model="item.checked"
                            >{{item.fieldName}}</el-checkbox
                            > -->
                        <span
                          style="font-size: 12px; margin: 0px 10px 0px 0px"
                          >{{ item.fieldName }}</span
                        >
                        <el-form-item
                          :prop="'serviceCategoryVOS.' + index + '.value'"
                          :rules="{
                            required: true ,
                            message: `请输入${item.fieldName}分类展示名称`,
                            trigger: 'blur',
                          }"
                        >
                          <el-input
                            class="list-input myInput_config"
                            :maxlength="8"
                            v-model.trim="item.value"
                            :placeholder="`请输入${item.fieldName}分类展示名称`"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one" v-if="false">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">服务展示</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="服务" prop="service">
                <el-checkbox-group v-model="formList.service">
                  <el-checkbox label="应用" disabled></el-checkbox>
                  <el-checkbox label="流程"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">服务中心搜索</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="搜索框提示语" prop="serviceSearch">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="16"
                  v-model.trim="formList.serviceSearch"
                  placeholder="请输入搜索框提示语"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import { detailWG, submit } from "@/store/management/Myconfig"; //我的
import Sortable from "sortablejs";
export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      // color: '#FF4D4F',
      rules: {
        serviceSearch: [
          { required: true, message: "请选择搜索框提示语", trigger: "blur" },
        ],
      },
      formList: {
        id: "",
        serviceCategoryVOS: [
          {
            fieldName: "场景",
            fieldId: "1",
            checked: true,
            value: "",
          },
          {
            fieldName: "部门",
            fieldId: "2",
            checked: true,
            value: "",
          },
          {
            fieldName: "类型",
            fieldId: "3",
            checked: true,
            value: "",
          },
        ],
        cardNameVOS: [
          {
            fieldName: "常用服务",
            fieldId: "1",
            checked: true,
            value: "",
          },
          {
            fieldName: "推荐服务",
            fieldId: "2",
            checked: true,
            value: "",
          },
          {
            fieldName: "上新服务",
            fieldId: "3",
            checked: true,
            value: "",
          },
        ],
        serviceSearch: "",
      }, //数据
      fileList: [], //默认配置图
      dialogVisible: false,
      dialogImageUrl: "",
      adLandingBackImgList: [],
      adLandingLogoList: [],
      sysLogo: [],
      countNum: 1,
    };
  },
  created() {
    this.detailWGFN();
  },
  mounted() {
    this.initSortabelTwo();
  },
  methods: {
    // 初始化拖拽
    initSortabelTwo() {
      try {
        const el = document.querySelector(".one-list-two .list-one-line");
        // console.log(el)
        // 阻止火狐默认搜索事件
        el.ondrop = (evt) => {
          evt.stopPropagation();
          evt.preventDefault();
        };
        const Vm = this;
        Vm.sortable = new Sortable(el, {
          animation: 300,
          onEnd(evt) {
            // 拖拽结束发生该事件
            Vm.formList.serviceCategoryVOS.splice(
              evt.newIndex,
              0,
              Vm.formList.serviceCategoryVOS.splice(evt.oldIndex, 1)[0]
            );
            const newArray = Vm.formList.serviceCategoryVOS.slice(0);
            Vm.formList.serviceCategoryVOS = [];
            console.log(window.scrollY);
            console.log(document.querySelector(".third-formOne").scrollTop);
            // 保存当前滚动高度
            // const scrollTopH =
            //   document.querySelector(".third-formOne").scrollTop;
            Vm.$nextTick(() => {
              Vm.formList.serviceCategoryVOS = newArray;
              Vm.sortable = null;
              Vm.$nextTick(() => {
                Vm.initSortabelTwo();
                // document.querySelector(".third-formOne").scrollTop +=
                //   scrollTopH;
              });
              console.log(Vm.formList.serviceCategoryVOS);
            });
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    toPreview() {
      // this.$router.push({
      //   name: 'previewAdvanceLanding'
      // });
      const strData = JSON.stringify(this.formList);
      sessionStorage.setItem("formValue", strData);
      const url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "#/previewAdvanceLanding";
      window.open(url);
    },
    // 预登陆logo成功回调函数
    getAdLandingLogo(response) {
      console.log("data", response);
      this.formList.advanceLogo = response.result;
    },
    removeAdLandingLogo() {
      this.formList.advanceLogo = "";
      this.adLandingLogoList = [];
      // console.log(fileList)
    },
    removeSysLogo() {
      this.formList.logo = "";
      this.sysLogo = [];
      console.log(fileList);
    },
    // 系统logo成功回调函数
    getSysLogo(response) {
      this.formList.logo = response.result;
      console.log(fileList);
    },
    removeAdLandingBackImg() {
      this.formList.advanceBackground = "";
      this.adLandingBackImgList = [];
    },
    // 预登陆背景成功回调函数
    getAdLandingBackImg(response) {
      console.log("result", response);
      this.formList.advanceBackground = response.result;
    },
    handleExceed() {
      this.$message.error("一次只能上传一张图片");
    },
    //保存
    submitFN() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.formList.validate((valid) => {
          if (valid) {
            try {
              const params = this.formList;
              console.log(params);
              //   return
              this.submit();
            } catch (err) {
              this.countNum = 1;
              console.log(err);
            }
          } else {
            return false;
          }
        });
      });
    },
    //保存
    async submit() {
      // console.log(this.formList.showIdentityVOS)
      // return
      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch(
          "platformCardServiceConfigSubmit",
          this.formList
        );
        if (status === 1000) {
          console.log(result);
          this.$message.success(msg);
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //重置
    Reset() {
      this.$refs["formList"].resetFields();
      this.fileList = [];
      this.adLandingBackImgList = [];
      this.sysLogo = [];
      this.adLandingLogoList = [];
      this.detailWGFN();
    },
    //获取数据
    async detailWGFN() {
      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch(
          "platformCardServiceConfigQueryServiceCardConfigDetail",
          {}
        );
        if (status === 1000) {
          console.log(result);
          // this.$message.success(msg)
          Object.assign(this.formList, result);
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //上传之前
    beforeUpload(file) {
      const isJPG = ["image/png", "image/jpg", "image/jpeg"].indexOf(file.type);

      if (isJPG == -1) {
        this.$message.error("上传头像只能是png jpg jpeg图片格式!");
        return false;
      }

      const imgsize = file.size / 1024 / 1024 <= 5;
      if (!imgsize) {
        this.$message.error("上传图片最大5M, 请重新上传!");
        return false;
      }
    },
    //成功
    handleSuccess(file) {
      // console.log(file)
      this.formList.logo = file.result;
    },
    //点击
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //失败
    hadleError(err) {
      this.$message.error(err);
    },
    //移除
    handleRemove(file, fileList) {
      this.formList.logo = "";
      console.log("移除");
    },
    //关闭弹框
    closePreview() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.looking-setting {
  .phon-right {
    position: relative;
    // border:1px solid red;
    width: 40%;
    display: inline-block;
    // height:calc(100vh - 102px);
    height: 100%;
    border-left: 1px solid #dcdee2;
    img {
      // border: 1px solid red;
      width: 389px;
      height: 669px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .advance-theme {
    .el-button {
      margin-left: 0 !important;
    }
  }
  .myform {
    .el-form-item__label {
      padding-right: 10px;
    }
  }
  .myInput_config {
    width: 298px !important;
  }
  .palTel {
    font-size: 14px !important;
  }
  .my-upload {
    height: 115px;
    position: relative;
    .el-upload--picture-card {
      width: 80px !important;
      height: 80px !important;
      line-height: 80px !important;
      float: left;
      overflow: hidden;
    }
    .el-upload-list__item {
      width: 204px !important;
      height: 80px !important;
      margin-left: 14px !important;
    }
    .my-upload-footer {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
